export default {"src":"/_next/static/media/pears.e813974f.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};